import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Home from './pages/Home'
import Location from './pages/Location'
import About from './pages/About'
import LiveStream from './pages/LiveStream'
import Videos from './pages/Videos'
import VideoPage from './pages/VideoPage'
import Event from './pages/Event'
import Admin from './admin/pages/Admin'
import Sermon from './admin/pages/Sermon'
import Holy from './admin/pages/Holy'
import ViewYo from './admin/pages/ViewYo'

import Login from './pages/Login'
import Fast from './pages/Fast'
import Register from './pages/Register'
import TestLogin from './pages/TestLogin'

import AddBook from './admin/pages/AddBook'
import AddYoruba from './admin/pages/AddYoruba'

import Get from './admin/pages/Get'
import PromotionLogin from './pages/PromotionLogin'
import PromotionPage from './pages/PromotionPage'
import Pay from './admin/pages/Pay'
import Radio from './admin/pages/Radio'
import Video from './pages/Video'
import ViewSermon from './pages/ViewSermon'
import Interact from './pages/Interact'
import Test from './pages/Test'
import ViewParticipant from './pages/ViewParticipant'
import QuizResult from './pages/QuizResult'
import QuizResultsPage from './pages/QuizResultsPage'

function App() {
  return (
    <div className='w-screen h-full bg-white font-mono'>
      <BrowserRouter>
        <Routes>
          <Route path={"/"} element={<Home />}/>
          <Route path={"/locate"} element={<Location />}/>
          <Route path={"/about"} element={<About/>} />
          <Route path={"/livestream"} element={<LiveStream/>} />
          <Route path={"/live"} element={<Videos/>} />
          <Route path={"/register"} element={<Register/>} />
          {/* <Route path={"/testlogin"} element={<TestLogin/>} />
          <Route path={"/test"} element={<Test/>} /> */}
          {/* <Route path={"/quiz-result"} element={<QuizResult/>} /> */}
          <Route path={"/viewparticipant"} element={<ViewParticipant/>} />
          <Route path={"/QuizResultsPage"} element={<QuizResultsPage/>} />
          <Route path={"/videos"} element={<Video/>} />
          <Route path={"/interact"} element={<Interact/>} />


          <Route path={"/podcast"} element={<VideoPage/>} />
          <Route path={"/sermon"} element={<ViewSermon/>} />
          <Route path={"/fast"} element={<Fast/>} />

          <Route path={"/events"} element={<Event/>} />
          <Route path={"/login"} element={<Login/>} />
          <Route path={"/promologin"} element={<PromotionLogin/>} />
          <Route path={"/promo"} element={<PromotionPage/>} />
          <Route path={"/radio"} element={<Radio/>} />


          <Route path={"/addbook"} element={<AddBook/>} />
          <Route path={"/get"} element={<Get/>} />
          <Route path={"/pay"} element={<Pay/>} />
          <Route path={"/add"} element={<Admin/>} />
          <Route path={"/addyoruba"} element={<AddYoruba/>} />

          <Route path={"/sermon"} element={<Sermon/>} />
          <Route path={"/holy"} element={<Holy/>}  />
          <Route path={"/viewyo"} element={<ViewYo/>}  />



        </Routes>
      </BrowserRouter>
      
    </div>
  )
}

export default App